module.exports = __webpack_public_path__ + "static/img/14.50e36b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/14.png
// module id = WMxh
// module chunks = 0